/**
 * @generated SignedSource<<8047e4a6de32880c0dfb312dfa94e93b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddPlayersStepClientProfile$data = {
  readonly member: {
    readonly club: {
      readonly " $fragmentSpreads": FragmentRefs<"AddPlayers_Clients">;
    };
  } | null | undefined;
  readonly " $fragmentType": "AddPlayersStepClientProfile";
};
export type AddPlayersStepClientProfile$key = {
  readonly " $data"?: AddPlayersStepClientProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddPlayersStepClientProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "players"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddPlayersStepClientProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "member",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Club",
          "kind": "LinkedField",
          "name": "club",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "players",
                  "variableName": "players"
                }
              ],
              "kind": "FragmentSpread",
              "name": "AddPlayers_Clients"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ClientProfile",
  "abstractKey": "__isClientProfile"
};

(node as any).hash = "d329339f3b046cbcc7099452339fc75a";

export default node;
